import { ICurrentUser } from '@dadohr/shared/domainTypes/currentUser';
import {
  USER_LEVEL_SCOPES_BY_ROLE,
  UserLevelScope
} from '@dadohr/shared/domainTypes/permissions';
import { IRoute } from '@dadohr/shared/domainTypes/routes';
import { uniq } from 'lodash';

export const getCurrentUserScopes = (user: ICurrentUser) => {
  const v2 = user.org.permissions[user.id]?.v2;
  const additionalScopesForUser = v2?.scopes || [];
  const scopesForRole = v2?.role ? USER_LEVEL_SCOPES_BY_ROLE[v2.role] : null;
  return uniq([...additionalScopesForUser, ...(scopesForRole?.() || [])]);
};

const _hasUserLevelScopes = (
  // Might make sense to make this signature a little more
  // difficult to use, so that switch ups cannot happen
  givenScopes: UserLevelScope[],
  requiredScopes: UserLevelScope[]
) => {
  return requiredScopes.every((s) => givenScopes.includes(s));
};

export const hasUserLevelScopes = (
  user: ICurrentUser,
  requiredScopes: UserLevelScope[]
) => {
  return _hasUserLevelScopes(getCurrentUserScopes(user), requiredScopes);
};

export const hasPermissionToAccessPage = (
  user: ICurrentUser,
  route: IRoute
) => {
  return _hasUserLevelScopes(
    getCurrentUserScopes(user),
    route.requiredScopes || []
  );
};

const hasAdditionalExperienceTemplateScopes = (
  currentUser: ICurrentUser,
  tplId: string,
  requiredScopes: ('view' | 'edit' | 'launch')[]
) => {
  const givenSopes =
    currentUser.org.permissions[currentUser.id]?.v2.additionalExpTplScopes[
      tplId
    ] || [];
  return requiredScopes.every((s) => givenSopes.includes(s));
};

export const hasCurrentUserExperienceLevelScopes = (
  currentUser: ICurrentUser,
  tplId: string,
  scopes: ('launch' | 'view' | 'edit')[]
) => {
  if (
    _hasUserLevelScopes(
      getCurrentUserScopes(currentUser),
      scopes.map((x) => `experience.template.${x}` as const)
    )
  ) {
    return true;
  }
  return hasAdditionalExperienceTemplateScopes(currentUser, tplId, scopes);
};
